export const eventLocation = {
    cardContentItem: {
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        lineHeight: 1,
      },
} as const;